/* eslint-disable no-underscore-dangle */


const cardUsage = (data, cardUsageData) => {
  const keysObj = [];
  let key;
  let teamKey;

  data.userExpenses.forEach((expData) => {

    if (expData.user) {
      key = expData.user.id;

      if (!(key in keysObj)) {
        keysObj[key] = [];
        cardUsageData.push({
          amount: expData.amount,
          userId: key,
          teamId: expData.group.id,
          firstName: expData.user.firstName,
          lastName: expData.user.lastName,
          teamName: expData.group.groupName,
          allocatedAmt: 0,
        });
        keysObj[key][expData.group.id] = expData.amount;
      } else {
        teamKey = expData.group.id;
        if (!(teamKey in keysObj[key])) {
          keysObj[key][expData.group.id] = expData.amount;
          cardUsageData.push({
            amount: expData.amount,
            userId: key,
            teamId: expData.group.id,
            firstName: expData.user.firstName,
            lastName: expData.user.lastName,
            teamName: expData.group.groupName,
            allocatedAmt: 0,
          });
        } else {
          keysObj[key][expData.group.id] += expData.amount;
          const usageDetails = cardUsageData.find(obj => obj.userId === key && obj.teamId === expData.group.id);
          usageDetails.amount = keysObj[key][expData.group.id];
        }
      }
    }
  });


  cardUsageData.sort((a, b) => {
    const keyA = new Date(a.amount);
    const keyB = new Date(b.amount);
    // Compare the 2 dates
    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  });

  let counter = 0;
  let maxAmount = 0;
  cardUsageData.forEach((temp) => {
    if (counter === 0) {
      temp.allocatedAmt = 100;
      maxAmount = temp.amount;
    } else {
      temp.allocatedAmt = Math.round((temp.amount * 100) / maxAmount);
    }
    counter += 1;
  });

  return cardUsageData;
};

export {
  cardUsage as
  default,
};
